import { apiClient } from './client';

/**
 * Fetch Instagram posts with pagination support.
 * In live mode the backend proxies the Instagram Basic Display API.
 * In DB mode it returns manually curated posts.
 * @param {number} limit - Number of posts to fetch (default 9)
 * @param {number} offset - Starting offset for pagination (default 0)
 * @returns {Promise<Array>} List of Instagram posts
 */
export async function getInstagramPosts(limit = 9, offset = 0) {
  const response = await apiClient.get(`/api/v1/instagram?limit=${limit}&offset=${offset}`);
  return response.data;
}

/**
 * Fetch total count of available Instagram posts.
 * Used by the footer to control Load More button visibility.
 * @returns {Promise<{total: number, source: string}>}
 */
export async function getInstagramCount() {
  const response = await apiClient.get('/api/v1/instagram/count');
  return response.data;
}
